import type { PreBookingShipment } from "@freightsimple/generated-dashboard-openapi-client/models/PreBookingShipment";
import type { SavedLocation } from "@freightsimple/generated-dashboard-openapi-client/models/SavedLocation";
import { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import moment from "moment";

import BookShipmentAddressScreenComponent from "./CustomComponents/BookShipmentAddressScreenComponent";

interface BookShipmentPickupAddressScreenProps {
  shipment: PreBookingShipment;
  savedLocations: Array<SavedLocation>;
  loading: boolean;
  onComplete: () => void;
  onPrevious: () => Promise<void>;
  markLocationAsFavourite: boolean | undefined;
  onMarkLocationAsFavourite: (newValue: boolean) => void;
  onModify: () => void;
}

function BookShipmentPickupAddressScreen(
  props: BookShipmentPickupAddressScreenProps,
) {
  const isSameDayPickup =
    props.shipment.pickupDate === moment().format("YYYY-MM-DD");

  return (
    <BookShipmentAddressScreenComponent
      loading={props.loading}
      identifier={"pickup-address"}
      savedLocations={props.savedLocations}
      context={LocationContext.Pickup}
      shipment={props.shipment}
      nextIdentifier="delivery-address"
      onPrevious={props.onPrevious}
      onComplete={props.onComplete}
      markLocationAsFavourite={props.markLocationAsFavourite}
      onMarkLocationAsFavourite={props.onMarkLocationAsFavourite}
      onModify={props.onModify}
      isSameDayPickup={isSameDayPickup}
    />
  );
}

export default BookShipmentPickupAddressScreen;
